const getGoogleItem = (googleMapsObject, type) => googleMapsObject.types[0] === type;
export const getProvince = (googleMapsObject) => getGoogleItem(googleMapsObject, 'administrative_area_level_1');
export const getStreetNumber = (googleMapsObject) => getGoogleItem(googleMapsObject, 'street_number');
export const getRoute = (googleMapsObject) => getGoogleItem(googleMapsObject, 'route');
export const getCity = (googleMapsObject) => getGoogleItem(googleMapsObject, 'locality');
export const getPostal = (googleMapsObject) => getGoogleItem(googleMapsObject, 'postal_code');
export const getCountry = (googleMapsObject) => getGoogleItem(googleMapsObject, 'country');
export const getCounty = (googleMapsObject) => getGoogleItem(googleMapsObject, 'administrative_area_level_2');
export const checkRazorAddress = (addressObject) => {
  const successCount = Object.keys(addressObject).reduce((prev, next) => {
    if (addressObject[next] !== '') {
      return prev + 1;
    }
    return prev;
  }, 0);
  if (successCount === 4) {
    return addressObject;
  }
  return null;
};
